import { render, staticRenderFns } from "./add-site-team-members.vue?vue&type=template&id=54a5113c&scoped=true&"
import script from "./add-site-team-members.vue?vue&type=script&lang=js&"
export * from "./add-site-team-members.vue?vue&type=script&lang=js&"
import style0 from "./add-site-team-members.vue?vue&type=style&index=0&id=54a5113c&lang=scss&scoped=true&"
import style1 from "@/assets/range-slider.scss?vue&type=style&index=1&id=54a5113c&scoped=true&lang=scss&"
import style2 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=2&id=54a5113c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5113c",
  null
  
)

component.options.__file = "add-site-team-members.vue"
export default component.exports